:host {
  --uui-min-height: var(--uui-extra-small-spacing);
  --uui-margin-bottom: var(--uui-extra-small-spacing);
  --uui-border-radius: var(--uui-border-radius-sm);
  --uui-skeleton-line-color: var(--uui-gray-07); /* Skeleton line color */
  --uui-skeleton-highlight-color: var(--uui-gray-04);
  --uui-skeleton-animation-duration: 1.5s;
}

.loader-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.loader-item {
  height: var(--uui-min-height);
  margin-bottom: var(--uui-margin-bottom);
  background-color: var(--uui-skeleton-line-color);
  border-radius: var(--uui-border-radius);
  overflow: hidden;
  position: relative;
}

.loader-item::after {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background-repeat: no-repeat;
  background-image: linear-gradient(
    90deg,
    var(--uui-skeleton-line-color),
    var(--uui-skeleton-highlight-color),
    var(--uui-skeleton-line-color)
  );
  transform: translateX(-100%);
  animation-name: shimmer;
  animation-direction: normal;
  animation-duration: var(--uui-skeleton-animation-duration);
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

